import { FC, ReactNode, MouseEvent, CSSProperties } from 'react';
import cx from 'classnames';
import { noop } from '@/helpers';

import styles from './Button.module.sass';

type ButtonType =
  | 'primary'
  | 'secondary'
  | 'secondary-red'
  | 'bordered'
  | 'shadow'
  | 'orange'
  | 'primary-gradient'
  | 'primary-black'
  | 'primary-red';

type ButtonCornerType = 'rect' | 'round';

type ButtonSize = 'xs' | 's' | 'm' | 'l' | 'xl';

interface ButtonProps {
  disabled?: boolean;
  size?: ButtonSize;
  type?: ButtonType;
  corner?: ButtonCornerType;
  fullwidth?: boolean;
  minWidth?: CSSProperties['minWidth'];
  nowrap?: boolean;
  children: ReactNode;
  className?: string;
  isLoading?: boolean;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
}

const Button: FC<ButtonProps> = ({
  disabled = false,
  size = 'l',
  type = 'primary',
  corner = 'round',
  fullwidth = false,
  minWidth,
  nowrap,
  children,
  className,
  isLoading = false,
  onClick = noop,
}) => {
  const classes = cx(
    styles.button,
    [`${styles[`size-${size}`]}`],
    [`${styles[`type-${type}`]}`],
    [`${styles[`corner-${corner}`]}`],
    {
      [styles.loading]: isLoading,
      [styles.fullwidth]: fullwidth,
      [styles.nowrap]: nowrap,
    },
    className,
  );

  return (
    <button
      type="button"
      className={classes}
      style={{ minWidth: `${Number(minWidth) / 10}rem` }}
      onClick={onClick}
      disabled={disabled || isLoading}
    >
      {isLoading ? '' : children}
    </button>
  );
};

export default Button;
